// session缓存

const KEY_USER_EMAIL = 'userEmail';

export default{
	initUserEmail(e){
		sessionStorage.setItem(KEY_USER_EMAIL, e);
	},
	initUserVip(v){
		setSession('isVip', v);
	},
	initUserVipLevel(level){
		setSession('vipLevel', level);
	},
	isUserVip(){
		return getSession('isVip') == true;
	},
	getVipLevel(){
		return getSession('vipLevel');
	},
	setFromAliyun(value){
		if(value == true){
			sessionStorage.setItem('FromAliyun', true);
		}else {
			sessionStorage.setItem('FromAliyun', false);
		}
	},
	isFromAliyun(){
		return sessionStorage.getItem('FromAliyun');
	},
	bell(key){
		let email = sessionStorage.getItem(KEY_USER_EMAIL);
		key = email + key;
		let result = getLocal(key);
		if(result == null){
			setLocal(key, true);
		}
		return result == null;
	},
	// 新手引导：已默认关闭
	guideShown(){
		return false;
	},
	// 清除Session数据
	clear(){
		sessionStorage.clear();
	},
	// jwt
	saveAuthorization(token){
		sessionStorage.setItem('Authorization', token);
	},
	getAuthorization(){
		return sessionStorage.getItem('Authorization');
	},
	// userinfo
	getUserInfo(){
		return getSession("userinfo")
	},
	setUserInfo(value){
		setSession("userinfo", value)
	},
	// gifts
	getGifts(){
		return getSession("gifts")
	},
	setGifts(value){
		setSession("gifts", value)
	},
	// order
	getOrder(id){
		return getSession("order_" + id)
	},
	saveOrder(id, value){
		setSession("order_" + id, value)
	},
	// drives
	setCloudPath(value){
		setSession("cloudPath", value)
	},
	getCloudPath(){
		return getSession("cloudPath")
	},
	setDriveAccount(authId, value){
		setSession(authId + "_driveAccount", value)
	},
	getDriveAccount(authId){
		return getSession(authId + "_driveAccount")
	},
	getNewDriveRefresh(){
		return getSession("newDriveRefresh")
	},
	setNewDriveRefresh(value){
		setSession("newDriveRefresh", value)
	},
	getDrives(){
		return getSession("drives")
	},
	setDrives(value){
		setSession("drives", value)
	},
	getDriveFiles(authId, folderId){
		return getSession("drive_file_" + authId + folderId);
	},
	setDriveFiles(authId, folderId, value){
		setSession("drive_file_" + authId + folderId, value);
	},
	// transfers
	getTransferPath(){
		return getSession("transfer_path")
	},
	setTransferPath(value){
		setSession("transfer_path", value)
	},
	getTransferList(){
		return getSession("transfer_list")
	},
	setTransferList(value){
		setSession("transfer_list", value)
	},
	getTransferTask(id){
		return getSession("transfer_task_" + id)
	},
	setTransferTask(id, value){
		setSession("transfer_task_" + id, value)
	},
	getTransferTaskProgress(sessionId){
		return getSession("transfer_task_progress" + sessionId)
	},
	setTransferTaskProgress(sessionId, value){
		setSession("transfer_task_progress" + sessionId, value)
	},
	// sync
	setSyncList(value){
		setSession("sync_list", value)
	},
}

function buildKey(key){
	let email = sessionStorage.getItem(KEY_USER_EMAIL);
	if(email){
		return email + "_" + key;
	}
	return sessionStorage.getItem('Authorization') + "_" + key;
}

function getSession(key){
	return JSON.parse(sessionStorage.getItem(buildKey(key)));
}

function setSession(key, value){
	return sessionStorage.setItem(buildKey(key), JSON.stringify(value))
}

function getLocal(key){
	let email = sessionStorage.getItem(KEY_USER_EMAIL);
	if(email){
		key = email + "_" + key;
	}
	return JSON.parse(localStorage.getItem(key));
}

function setLocal(key, value){
	let email = sessionStorage.getItem(KEY_USER_EMAIL);
	if(email){
		key = email + "_" + key;
	}
	return localStorage.setItem(key, JSON.stringify(value))
}
